module.exports = __webpack_public_path__ + "img/dashboardIcon3.eeb8c9c1.png";